import { flowApi } from '.';
import type { CreateOnlyOfficeSessionArgs, OnlyOfficeSession } from 'types/documentEditing';

export const documentEditingService = flowApi.injectEndpoints({
  endpoints: (builder) => ({
    createOnlyOfficeSession: builder.mutation<OnlyOfficeSession, CreateOnlyOfficeSessionArgs>({
      query: ({ agendaId, recordId, fileId, mode }) => ({
        url: `/Agendas/${agendaId}/Records/${recordId}/Files/${fileId}/OnlyOfficeSession`,
        method: 'POST',
        params: { mode },
        cache: 'no-store',
      }),
    }),
  }),
});

export const { useCreateOnlyOfficeSessionMutation } = documentEditingService;
